// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePicker_root__3VL-m","range":"DatePicker_range__JN7RR"};